var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9958 2.00016C16.9958 1.0835 16.2458 0.333496 15.3291 0.333496H1.99577C1.0791 0.333496 0.329102 1.0835 0.329102 2.00016V12.0002C0.329102 12.9168 1.0791 13.6668 1.99577 13.6668H15.3291C16.2458 13.6668 16.9958 12.9168 16.9958 12.0002V2.00016ZM15.3291 2.00016L8.66244 6.1585L1.99577 2.00016H15.3291ZM15.3291 12.0002H1.99577V3.66683L8.66244 7.8335L15.3291 3.66683V12.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactEmail);
export default __webpack_public_path__ + "static/media/ContactEmail.d910d5f1286fc9c330e6d8d31cc4085a.svg";
export { ForwardRef as ReactComponent };